import Point from '@arcgis/core/geometry/Point';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import * as projection from '@arcgis/core/geometry/projection';

export function buildBooleanOptions() {
    return [
        {
            title: 'NO',
            name: `id0`,
            value: false,
        },
        {
            title: 'SI',
            name: `id1`,
            value: true,
        },
    ];
}

export function getDaysInMonth(month, year) {
    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
        days.push(new Date(date).getDate());
        date.setDate(date.getDate() + 1);
    }
    return days;
}

export function isEqualArray(a, b) {
    if (a.length !== b.length) return false;
    const uniqueValues = new Set([...a, ...b]);
    for (const v of uniqueValues) {
        const aCount = a.filter((e) => e === v).length;
        const bCount = b.filter((e) => e === v).length;
        if (aCount !== bCount) return false;
    }
    return true;
}

export function formatNumber(num = 1, size = 4) {
    let NUM = num.toString();
    while (NUM.length < size) NUM = '0' + NUM;
    return NUM;
}

export function formatNumberLength(num = 1, size = 8) {
    let NUM = num.toString();
    return NUM.slice(0, size);
}

export function imageFileToBase64(file) {
    return new Promise((resolve) => {
        let fileInfo;
        let baseURL = '';
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            baseURL = reader.result;
            resolve(baseURL);
        };
        return fileInfo;
    });
}

export function formatCoordinates(x, y) {
    const NewPoint = new Point({
        x,
        y,
        spatialReference: new SpatialReference({
            wkid: 32721,
        }),
    });

    return projection.load().then(function () {
        let outSpatialReference = new SpatialReference({
            wkid: 102100, //Sphere_Sinusoidal projection
        });
        let convertedPoint = projection.project(NewPoint, outSpatialReference);
        return [convertedPoint?.latitude, convertedPoint?.longitude];
    });

    // return [convertedPoint.latitude, convertedPoint.longitude];
}
